import { useTranslation } from 'react-i18next'

import { SkeletonLoading } from 'app/common/templates-next/page-template'

import { useBankCardUrlWithCrossAuthToken } from './use-bank-card-url-with-cross-auth-token'
import styles from './identifier-form-bank-card.module.scss'
import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button'

type Props = {
  accountID: string
  asNewPageLink?: boolean
}

export const IdentifierFormBankCard = ({ accountID, asNewPageLink }: Props) => {
  const { t } = useTranslation('identifiers-next')
  const { url } = useBankCardUrlWithCrossAuthToken(accountID)

  const { href } = window.location
  const externalUrl = url ? `${url}&return_url=${href}` : ''

  if (asNewPageLink) {
    return (
      <div className={styles.buttonContainer}>
        <PlainLinkAsButton
          to={externalUrl}
          disabled={!url}
          className={styles.button}
          openInSameWindow
          outline
        >
          {t('add_identifier_new_browser_tab', 'Добавить')}
        </PlainLinkAsButton>
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <SkeletonLoading className={styles.loading} rows={16} />
      {url && (
        <iframe
          src={url}
          scrolling="no"
          className={styles.frame}
          title={t('bank_card_frame_title', 'Банковская карта') as string}
          // @ts-ignore
          allowpaymentrequest="true" // eslint-disable-line react/no-unknown-property
        >
          {t(
            'frame_error',
            'Извините, ваш браузер не поддерживает встроенные фреймы, вы не сможете добавить банковскую карту! Попробуйте в другом браузере.',
          )}
        </iframe>
      )}
    </div>
  )
}
